import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CartDetail" })
export default class CartDetail extends Vue {
    public validationErrors: any[] = [];
    public isLoading: boolean = false;
    public isGAEventSent: boolean = false;
    public isCartEmpty: boolean = true;
    public clonedCart: any = null;
    public cartDetailInfo: any = null;

    @Prop() readonly isUserAuthenticated: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    public async created() {
        await Promise.all([this.getData(), this.getCart()]);
    }

    public async getData() {
        this.cartDetailInfo = (await Axios.post(this.routes.Cart_GetCartDetailInfo)).data;
    }

    public async getCart() {
        await this.$store.dispatch("cartStore/getCart");
        this.clonedCart = this.cart;
        this.isCartEmpty = this.cart == null || this.cart.cartRows == null || this.cart.cartRows.length == 0;
    }

    public setCart(cartInfo: any) {
        this.$store.dispatch("cartStore/setCart", cartInfo);
        this.clonedCart = this.cart;
        this.isCartEmpty = this.cart == null || this.cart.cartRows == null || this.cart.cartRows.length == 0;
    }

    public addQuantity(cartRow: any) {
        cartRow.quantity ? cartRow.quantity++ : cartRow.quantity = 1;
        if (cartRow.quantity > 100) {
            cartRow.quantity = 100;
        }
    }

    public removeQuantity(cartRow: any) {
        cartRow.quantity > 1 ? cartRow.quantity-- : cartRow.quantity = 1;
    }

    public async updateQuantity(cartRow: any) {
        this.isLoading = true;
        FormHelper.removeFocus();
        this.validationErrors = [];

        if (cartRow.quantity == "") {
            let name = "Quantity_" + cartRow.productCode;
            this.validationErrors.push({ name: name, message: "Quantità non valida" });
        } else {
            try {
                const result = (await Axios.post(this.routes.Cart_UpdateQuantity, { cartRowCode: cartRow.cartRowCode, quantity: cartRow.quantity })).data;

                this.setCart(result.cartInfo);

                this.bindCartRow(cartRow.cartRowCode, result.cartInfo);
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoading = false;
    }

    public async remove(cartRow: any) {
        FormHelper.removeFocus();
        this.validationErrors = [];
        let deletedProduct = this.cart.cartRows.find(x => x.cartRowCode === cartRow.cartRowCode);

        try {
            const result = (await Axios.post(this.routes.Cart_RemoveProduct, { cartRowCode: cartRow.cartRowCode })).data;

            await this.getCart();

            GTagHelper.sendCustomEvent("remove_from_cart", {
                currency: "EUR",
                value: parseFloat(deletedProduct.rowPriceIVA.replace(/\./g, "").replace(",", ".")),
                items: [
                    {
                        item_id: deletedProduct.productCode,
                        item_name: deletedProduct.productTitle,
                        affiliation: "C&DElettronica",
                        currency: "EUR",
                        item_category: deletedProduct.categoryName,
                        price: parseFloat(deletedProduct.unitPrice.replace(/\./g, "").replace(",", ".")),
                        quantity: deletedProduct.quantity
                    }
                ]
            });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async setCouponCode() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            const result = (await Axios.post(this.routes.Cart_SetCouponCode, { couponCode: this.clonedCart.couponCode })).data;

            this.setCart(result.cartInfo);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoading = false;
    }

    public updated() {
        this.$nextTick(function () {
            if (this.cart && !this.isGAEventSent) {
                var itemList = [];

                for (var i in this.cart.cartRows) {
                    itemList.push({
                        item_id: this.cart.cartRows[i].productCode,
                        item_name: this.cart.cartRows[i].productTitle,
                        affiliation: "C&DElettronica",
                        currency: "EUR",
                        item_category: this.cart.cartRows[i].categoryName,
                        price: parseFloat(this.cart.cartRows[i].unitPrice.replace(/\./g, "").replace(",", ".")),
                        quantity: this.cart.cartRows[i].quantity,
                        coupon: this.cart.couponCode
                    });
                }

                GTagHelper.sendCustomEvent("view_cart", {
                    currency: "EUR",
                    value: parseFloat(this.cart.cartTotalIVA.replace(/\./g, "").replace(",", ".")),
                    items: itemList
                });

                this.isGAEventSent = true;
            }
        });
    }

    public bindCartRow(cartRowCode, cartDetail) {
        var cartRow = document.querySelector("#CartRow_" + cartRowCode);

        for (var i = 0, length = cartDetail.cartRows.length; i < length; i += 1) {
            if (cartRowCode === cartDetail.cartRows[i].cartRowCode) {
                cartRow.setAttribute("data-add", "");
            }
        }

        setTimeout(function () { $(".tr[data-add]").removeAttr("data-add"); }, 1500);
    };

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};